// EmailJS Configuration
export const EMAILJS_CONFIG = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_ibieoe2',
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_byz4z5j',
  autoReplyTemplateId: process.env.REACT_APP_EMAILJS_AUTO_REPLY_TEMPLATE_ID || 'template_37qci8p',
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'OAndyz5dg2gxqBntR'
};
